import {
  RequestableState,
  createRequestableState,
  handleStarting,
} from '@tock/shared/state/requestableState';
import { SharedAppConstants } from '@tock/shared-app-constants';
import { dashboard } from 'types';
import { payloadToJSON } from '@tock/coretypes';

type State = RequestableState<dashboard.BusinessInventoryScheduleHistory[]>;

const initialState: State = createRequestableState<dashboard.BusinessInventoryScheduleHistory[]>();

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type } = action;

  switch (type) {
    case SharedAppConstants.BUSINESS_INVENTORY_SCHEDULE_HISTORY_FETCH_STARTING: {
      return handleStarting(state, action);
    }
    case SharedAppConstants.BUSINESS_INVENTORY_SCHEDULE_HISTORY_FETCH_FAILED: {
      return {
        ...state,
        isRequesting: false,
      };
    }
    case SharedAppConstants.BUSINESS_INVENTORY_SCHEDULE_HISTORY_FETCH_DONE: {
      return {
        ...state,
        isRequesting: false,
        data: !state.data
          ? [payloadToJSON(action.payload)]
          : state.data.map((history) =>
              history.id === action.payload.id ? payloadToJSON(action.payload) : history
            ),
      };
    }

    default:
      return state;
  }
}
